module.exports = __webpack_public_path__ + "img/form-bg2.93f8eb6a.png";